// extracted by mini-css-extract-plugin
module.exports = {"tiles":"styles_tiles__9kICb","tile":"styles_tile__ixiBZ"};